import { Link as ChakraLink, LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';
import { FC } from 'react';

export const TransNextLink: FC<Omit<NextLinkProps, 'passHref'> & Omit<ChakraLinkProps, 'as'>> = ({
  children,
  href,
  as,
  replace,
  scroll,
  shallow,
  prefetch,
  locale,
  ...rest
}) => (
  <NextLink
    href={href}
    as={as}
    replace={replace}
    scroll={scroll}
    shallow={shallow}
    prefetch={prefetch}
    locale={locale}
    passHref
    legacyBehavior
  >
    <ChakraLink {...rest}>{children}</ChakraLink>
  </NextLink>
);
